import { render, staticRenderFns } from "./bookshelves.vue?vue&type=template&id=68647c09&scoped=true&"
import script from "./bookshelves.vue?vue&type=script&lang=js&"
export * from "./bookshelves.vue?vue&type=script&lang=js&"
import style0 from "./bookshelves.vue?vue&type=style&index=0&id=68647c09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68647c09",
  null
  
)

component.options.__file = "bookshelves.vue"
export default component.exports